import { colors, typography, effects } from "../../../design/tokens";

interface SideMenuNavItemProps {
  id?: string;
  icon: React.ReactNode;
  label: string;
  onClick: () => void;
  isSelected?: boolean;
}

export default function SideMenuNavItem({
  id,
  icon,
  label,
  onClick,
  isSelected = false,
}: SideMenuNavItemProps): JSX.Element {
  const selectedClass = isSelected ? colors.surface.secondary : "";

  return (
    <button
      id={id}
      className={`w-full py-2 px-2 ${effects.borderRadius.lg} ${selectedClass}
        ${colors.hover.backgroundAlt} cursor-pointer transition-colors`}
      onClick={onClick}
    >
      <div className="grid grid-cols-[24px_1fr] items-center gap-3">
        <div className="flex items-center justify-center">{icon}</div>
        <span className={`${typography.size.sm} ${typography.weight.medium} ${colors.text.primary} text-left`}>
          {label}
        </span>
      </div>
    </button>
  );
}
